





<div class="box">
  <div class="box-header">
    <div class="flex-align-center py-2 px-3" style="justify-content: center!important;margin-top: 10px;">



      <form [formGroup]="reportForm">
        <mat-radio-group aria-label="Select an option"   formControlName="selectedReport" (change)="onReportSelect()">
          <mat-radio-button value="1">{{'Signed Reports' | translate}}</mat-radio-button>
          @if (userData.roleId<4) {
            <mat-radio-button value="2">{{'Unsigned Packages Report' | translate}}</mat-radio-button>
          }
          @if (userData.roleId<4) {
            <mat-radio-button value="3">{{'MAR Report'| translate}}</mat-radio-button>
          }
          @if (userData.roleId<4) {
            <mat-radio-button value="4">{{'Missing Signature Report'| translate}}</mat-radio-button>
          }
          @if (userData.roleId<4) {
            <mat-radio-button value="5">{{'Exception Report' | translate}}</mat-radio-button>
          }
          <mat-radio-button value="6" >{{'ESA Report' | translate}}</mat-radio-button>
        </mat-radio-group>
      </form>
    </div>
  </div>
  <div class="box-body" style="margin-top: 10px;">

    <!-- <nav mat-tab-nav-bar [backgroundColor]="background" mat-align-tabs="center">
    <a mat-tab-link *ngFor="let link of navLinks"
      [routerLink]="link.path"
      (click)="activateLink(link)"
    [active]="activeLink.path == link.path"> {{ link.label }} </a>

  </nav> -->




  <router-outlet></router-outlet>

</div>
</div>








